import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgxSpinnerModule } from 'ngx-spinner';
import { PopupModule } from 'src/app/popup/popup.module';

import { RecipeComponent } from './recipe.component';
@NgModule({
  declarations: [RecipeComponent],
  imports: [CommonModule, FormsModule, NgxSpinnerModule, PopupModule],
  exports: [RecipeComponent],
})
export class RecipeModule {}
